module.exports = __webpack_public_path__ + "assets/img/user-empty.333fd7a4.svg";